import {
  addNoteToApplicantBDM,
  updateAllOtherSourceNotes,
  updateAllOtherSourceVisitHistory,
  addVisitHistoryToApplicantBDM,
} from "../../../redux/slices/bdmjobs/bdmjobsSlice";
import {
  addNoteToApplicant,
  updateAllSourceNotes,
  updateExistingCandidates,
  updateAllSourceVisitHistory,
  addVisitHistoryToApplicant,
} from "../../../redux/slices/internalDbES/internalDbESlice";
import {
  updateApplicantNotes,
  updateApplicantWithNotes,
  updateApplicantVisitHistory,
} from "../../../redux/slices/recruitmentSourcing/SourcingSlice";

const getSocketDoc = (packet) => {
  const rawData = packet?.data?.response || packet?.data || {};
  return rawData?.doc || rawData;
};

const getCandidateUiid = (data) => data?.candidateId?.uiid || data?.candidateId;

const handlePost = (dispatch) => (packet) => {
  const title = packet?.title;
  const data = getSocketDoc(packet);

  if (!title || !data) return;

  switch (title) {
    case "Note": {
      const candidateUiid = getCandidateUiid(data);
      const noteUiid = data?.uiid || data?._id;

      if (!candidateUiid || !noteUiid) {
        break;
      }

      const payload = {
        applicantId: candidateUiid,
        newNoteUiid: noteUiid,
        uiid: noteUiid,
        note: data?.note,
        addedBy: data?.addedBy,
        addedOn: data?.addedOn,
      };

      dispatch(updateApplicantNotes(payload));
      dispatch(updateAllSourceNotes(payload));
      dispatch(updateAllOtherSourceNotes(payload));
      dispatch(updateApplicantWithNotes(payload));
      dispatch(addNoteToApplicant(payload));
      dispatch(addNoteToApplicantBDM(payload));
      break;
    }
    case "VisitHistory": {
      const candidateUiid = getCandidateUiid(data);

      if (!candidateUiid) {
        break;
      }

      const payload = {
        applicantId: candidateUiid,
        visitHistory: data,
        uiid: data?.uiid,
        addedBy: data?.addedBy,
        addedOn: data?.addedOn,
      };

      dispatch(updateApplicantVisitHistory(payload));
      dispatch(updateAllSourceVisitHistory(payload));
      dispatch(updateAllOtherSourceVisitHistory(payload));
      dispatch(addVisitHistoryToApplicant(payload));
      dispatch(addVisitHistoryToApplicantBDM(payload));
      break;
    }
    case "Order":
      break;
    case "monster":
      dispatch(
        updateExistingCandidates({
          source: "monster",
          candidate: data,
        }),
      );
      break;
    case "careerbuilder":
      dispatch(
        updateExistingCandidates({
          source: "careerBuilder",
          candidate: data,
        }),
      );
      break;
    default:
      return;
  }
};

export default handlePost;
